import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const TrendingDown = ({
  className = "text-primary",
  viewBox = "0 0 44 44",
  width = 44,
  height = 44,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    fill="none"
  >
    <title>TrendingDown</title>
    <path
      d="M29.3337 33L33.532 28.8017L24.5853 19.855L17.252 27.1883L3.66699 13.585L6.25199 11L17.252 22L24.5853 14.6667L36.1353 26.1983L40.3337 22V33H29.3337Z"
      fill="currentColor"
    />
  </svg>
);
